/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import { ComponentBuilder } from "@sitecore-jss/sitecore-jss-react";
import ClientOnly from '../lib/ClientOnly';
import SampleComponent from "../renderings/SampleComponent";
import { ABAAssociatesQuoteCard } from "sitecore-mm-component-library";
import { ABAContactUs } from "sitecore-mm-component-library";
import { ABAFooterDisclosure } from "sitecore-mm-component-library";
import { ABALicenses } from "sitecore-mm-component-library";
import { ABAUserList } from "sitecore-mm-component-library";
import { Accordion } from "sitecore-mm-component-library";
import { AgencySearch } from "sitecore-mm-component-library";
import { AgentProfileBreadcrumb } from "sitecore-mm-component-library";
import { AlertNotification } from "sitecore-mm-component-library";
import { BackgroundCard } from "sitecore-mm-component-library";
import { BlogCardList } from "sitecore-mm-component-library";
import { BlogHero } from "sitecore-mm-component-library";
import { BlogList } from "sitecore-mm-component-library";
import { BlogListByCategory } from "sitecore-mm-component-library";
import { BlogPinPost } from "sitecore-mm-component-library";
import { BlogRelatedArticles } from "sitecore-mm-component-library";
import { BlogSideBar } from "sitecore-mm-component-library";
import { Breadcrumb } from "sitecore-mm-component-library";
import { BrokerageDirectorProfile } from "sitecore-mm-component-library";
import { CCPAForm } from "sitecore-mm-component-library";
import { CalculatorAccordion } from "sitecore-mm-component-library";
import { CalculatorCard } from "sitecore-mm-component-library";
import { CallOutCard } from "sitecore-mm-component-library";
import { CardLinkList } from "sitecore-mm-component-library";
import { CardList } from "sitecore-mm-component-library";
import { ColumnSubLayout } from "sitecore-mm-component-library";
import { ConditionalNav } from "sitecore-mm-component-library";
import { ContactCard } from "sitecore-mm-component-library";
import { ContactModalList } from "sitecore-mm-component-library";
import { FeaturedStats } from "sitecore-mm-component-library";
import { FinProSearch } from "sitecore-mm-component-library";
import { FinProSimpleSearch } from "sitecore-mm-component-library";
import { FinproAgencyProfile } from "sitecore-mm-component-library";
import { FinproAgentProfile } from "sitecore-mm-component-library";
import { FinproStateDisplay } from "sitecore-mm-component-library";
import { Hero } from "sitecore-mm-component-library";
import { HorizontalCard } from "sitecore-mm-component-library";
import { HorizontalLineCard } from "sitecore-mm-component-library";
import { HorizontalTimeline } from "sitecore-mm-component-library";
import { JssForm } from "sitecore-mm-component-library";
import { LoginCard } from "sitecore-mm-component-library";
import { MMFAForm } from "sitecore-mm-component-library";
import { MediaCard } from "sitecore-mm-component-library";
import { MediaColumn } from "sitecore-mm-component-library";
import { MediaHorizontalCard } from "sitecore-mm-component-library";
import { ModalWindow } from "sitecore-mm-component-library";
import { PersonalizedModal } from "sitecore-mm-component-library";
import { PressReleaseFilter } from "sitecore-mm-component-library";
import { PressReleaseList } from "sitecore-mm-component-library";
import { Rates } from "sitecore-mm-component-library";
import { ScrollSpyNav } from "sitecore-mm-component-library";
import { StyledHeading } from "sitecore-mm-component-library";
import { TabNav } from "sitecore-mm-component-library";
import { TabNavHorizontal } from "sitecore-mm-component-library";
import { TabNavVertical } from "sitecore-mm-component-library";
import { TitleTaglineDisplay } from "sitecore-mm-component-library";
import { VerticalCard } from "sitecore-mm-component-library";
import { VerticalTimeline } from "sitecore-mm-component-library";
import { VideoPlayer } from "sitecore-mm-component-library";

const components = new Map();
components.set("SampleComponent", SampleComponent);
components.set("ABAAssociatesQuoteCard", ABAAssociatesQuoteCard);
components.set("ABAContactUs", ABAContactUs);
components.set("ABAFooterDisclosure", ABAFooterDisclosure);
components.set("ABALicenses", ABALicenses);
components.set("ABAUserList", ABAUserList);
components.set("Accordion", Accordion);
components.set("AgencySearch", AgencySearch);
components.set("AgentProfileBreadcrumb", AgentProfileBreadcrumb);
components.set("AlertNotification", AlertNotification);
components.set("BackgroundCard", BackgroundCard);
components.set("BlogCardList", BlogCardList);
components.set("BlogHero", BlogHero);
components.set("BlogList", BlogList);
components.set("BlogListByCategory", BlogListByCategory);
components.set("BlogPinPost", BlogPinPost);
components.set("BlogRelatedArticles", BlogRelatedArticles);
components.set("BlogSideBar", BlogSideBar);
components.set("Breadcrumb", Breadcrumb);
components.set("BrokerageDirectorProfile", BrokerageDirectorProfile);
components.set("CCPAForm", CCPAForm);
components.set("CalculatorAccordion", CalculatorAccordion);
components.set("CalculatorCard", CalculatorCard);
components.set("CallOutCard", CallOutCard);
components.set("CardLinkList", CardLinkList);
components.set("CardList", CardList);
components.set("ColumnSubLayout", ColumnSubLayout);
components.set("ConditionalNav", ConditionalNav);
components.set("ContactCard", ContactCard);
components.set("ContactModalList", ContactModalList);
components.set("FeaturedStats", FeaturedStats);
components.set("FinProSearch", FinProSearch);
components.set("FinProSimpleSearch", FinProSimpleSearch);
components.set("FinproAgencyProfile", FinproAgencyProfile);
components.set("FinproAgentProfile", FinproAgentProfile);
components.set("FinproStateDisplay", FinproStateDisplay);
components.set("Hero", Hero);
components.set("HorizontalCard", HorizontalCard);
components.set("HorizontalLineCard", HorizontalLineCard);
components.set("HorizontalTimeline", HorizontalTimeline);
components.set("JssForm", JssForm);
components.set("LoginCard", LoginCard);
components.set("MMFAForm", MMFAForm);
components.set("MediaCard", MediaCard);
components.set("MediaColumn", MediaColumn);
components.set("MediaHorizontalCard", MediaHorizontalCard);
components.set("ModalWindow", (props) => React.createElement(ClientOnly, null, React.createElement(ModalWindow, props)));
components.set("PersonalizedModal", (props) => React.createElement(ClientOnly, null, React.createElement(PersonalizedModal, props)));
components.set("PressReleaseFilter", PressReleaseFilter);
components.set("PressReleaseList", PressReleaseList);
components.set("Rates", Rates);
components.set("ScrollSpyNav", ScrollSpyNav);
components.set("StyledHeading", StyledHeading);
components.set("TabNav", TabNav);
components.set("TabNavHorizontal", TabNavHorizontal);
components.set("TabNavVertical", TabNavVertical);
components.set("TitleTaglineDisplay", TitleTaglineDisplay);
components.set("VerticalCard", VerticalCard);
components.set("VerticalTimeline", VerticalTimeline);
components.set("VideoPlayer", VideoPlayer);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
